import * as React from 'react';
import { pluralize, scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';
import { PromoLink as PromoLinkComponent } from '../../components/PromoLink';
import { PROMO } from '../../constants/anchors';
import { getPromoCount } from '../../selectors/newbuilding';
import { trackMorePromosClick } from '../Promos/tracking';

export const PromoLink = () => {
  const count = useSelector(getPromoCount);

  if (count < 2) {
    return null;
  }

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: `#${PROMO}`,
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackMorePromosClick();
  };

  return (
    <PromoLinkComponent text={`Смотреть еще ${pluralize(count - 1, ['акцию', 'акции', 'акций'])}`} onClick={onClick} />
  );
};
